import { Container } from '@rxdi/core';
import { async } from '@rxdi/lit-html';

import { Registry } from './registry.modifier';
import { TranslateModifier } from './translate.modifier';
import { TranslateService } from './translate.service';

export const TranslateModifiers = [Registry, TranslateModifier];

export * from './translate.module';
export * from './translate.service';

export const translate = (v: string) => async(Container.get(TranslateService).get(v));
export const t = (v: string) => Container.get(TranslateService).get(v);
export const i18n = (v: string) => Container.get(TranslateService).get(v);
export const getCurrentLanguage = () => Container.get(TranslateService).currentLanguage;
export const getTranslateService = () => Container.get(TranslateService);
